import api from './api';
import { InmuebleOperacion, Ticket } from '../types/Ticket';

export const operacionTicketService = {
  crearOperacion: (inmuebleId: string, data: Partial<InmuebleOperacion>) =>
    api.post<InmuebleOperacion>(`/inmuebles/${inmuebleId}/operaciones`, data),

  getOperacionesByInmueble: (inmuebleId: string) =>
    api.get<InmuebleOperacion[]>(`/inmuebles/${inmuebleId}/operaciones`),

  getTicketsByOperacion: (inmuebleId: string, operacionId: string) =>
    api.get<Ticket[]>(`/inmuebles/${inmuebleId}/operaciones/${operacionId}/tickets`),
};
